import { Card, CardContent, PageHeader, SuspenseLoader, TabsMenu } from '@folio/components';
import { ClaimStatusBadge } from '@folio/components/module-elements/ClaimStatusBadge';
import { Stack } from '@folio/components/ui/flex';
import { useAssertedParams } from '@folio/lib';
import { useQuery } from '@tanstack/react-query';
import { claimManagementControllerGetQueryOptions } from 'korint-sdk';
import { useTranslation } from 'react-i18next';
import { Outlet } from 'react-router-dom';

export function ClaimDetailsLayout() {
  const { claimId } = useAssertedParams<{ claimId: string }>();
  const { t } = useTranslation();

  const { data: claim } = useQuery(claimManagementControllerGetQueryOptions(claimId));

  return (
    <Stack>
      <PageHeader
        title={<span className="break-all">{t('claimDetails.title', { claimId })}</span>}
      />
      {claim && (
        <Card>
          <CardContent>
            <dl className="text-sm">
              <dt className="text-xs text-muted-foreground">{t('claimDetails.status')}</dt>
              <dd className="mt-1">
                <ClaimStatusBadge claim={claim} />
              </dd>
            </dl>
          </CardContent>
        </Card>
      )}
      <TabsMenu
        tabs={[
          { label: t('claimDetails.tabs.information'), href: `/claims/${claimId}` },
          { label: t('claimDetails.tabs.parties'), href: `/claims/${claimId}/parties` },
          { label: t('claimDetails.tabs.documents'), href: `/claims/${claimId}/documents` },
        ]}
      />
      <SuspenseLoader>
        <Outlet />
      </SuspenseLoader>
    </Stack>
  );
}
